import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_vr-techsolutions/artifacts/9vnskgnq_Gemini_Generated_Image_lf1inhlf1inhlf1i.png";

const Header = ({ activeTab, setActiveTab }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { id: 'home', label: 'Inicio' },
    { id: 'outlet', label: 'Outlet' },
    { id: 'equipos', label: 'Equipos Nuevos' },
    { id: 'impresion3d', label: 'Impresión 3D' },
    { id: 'estudio', label: 'Estudio' },
    { id: 'web', label: 'Páginas Web' },
    { id: 'servicio', label: 'Servicio Técnico' },
    { id: 'contacto', label: 'Contacto' }
  ];

  const handleNavClick = (id) => {
    setActiveTab(id);
    setMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-md border-b border-violet-900/30">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <motion.div 
            className="flex items-center gap-3 cursor-pointer"
            onClick={() => handleNavClick('home')}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <img 
              src={LOGO_URL} 
              alt="SEBINOR Computación" 
              className="h-12 lg:h-14 w-auto object-contain"
              style={{ 
                filter: 'drop-shadow(0 0 10px rgba(139, 92, 246, 0.3))'
              }}
            />
            <div className="hidden sm:flex flex-col">
              <span 
                className="text-amber-400 text-sm lg:text-base"
                style={{ fontFamily: "'Dancing Script', cursive" }}
              >
                25 años con vos
              </span>
            </div>
          </motion.div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => handleNavClick(item.id)}
                className={`relative px-4 py-2 text-sm font-medium transition-colors duration-200 rounded-full
                  ${activeTab === item.id 
                    ? 'text-white' 
                    : 'text-gray-400 hover:text-white'
                  }`}
              >
                {activeTab === item.id && (
                  <motion.div
                    layoutId="activeTab"
                    className="absolute inset-0 bg-violet-600/20 border border-violet-500/30 rounded-full"
                    transition={{ type: 'spring', stiffness: 500, damping: 30 }}
                  />
                )}
                <span className="relative z-10">{item.label}</span>
              </button>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Button 
              onClick={() => handleNavClick('servicio')}
              className="bg-violet-600 hover:bg-violet-700 text-white rounded-full px-6 font-mono text-xs tracking-wider uppercase"
            >
              Solicitar Técnico
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden bg-black/95 border-b border-violet-900/30"
          >
            <nav className="flex flex-col p-4 gap-2">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => handleNavClick(item.id)}
                  className={`px-4 py-3 text-left rounded-lg transition-colors
                    ${activeTab === item.id 
                      ? 'bg-violet-600/20 text-white border border-violet-500/30' 
                      : 'text-gray-400 hover:text-white hover:bg-white/5'
                    }`}
                >
                  {item.label}
                </button>
              ))}
              <Button 
                onClick={() => handleNavClick('servicio')}
                className="mt-2 bg-violet-600 hover:bg-violet-700 text-white rounded-full font-mono text-xs tracking-wider uppercase"
              >
                Solicitar Técnico a Domicilio
              </Button>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
